"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const MainNavLeft_1 = require("./MainNavLeft");
exports.MainNav = ({ title, breadcrumbs, elementRight, loading, onClickMenuButton }) => (React.createElement("nav", { className: classNames('main-nav', { loading }) },
    React.createElement(MainNavLeft_1.MainNavLeft, { title: title, breadcrumbs: breadcrumbs, onClickMenuButton: onClickMenuButton }),
    elementRight && React.createElement("div", { className: "main-nav-right" }, elementRight)));
exports.MainNav.displayName = 'MainNav';
exports.MainNav.defaultProps = {
    loading: false,
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MainNav/MainNav.tsx
// module id = 359
// module chunks = 0